<div id="#kt_app_sidebar_menu" data-kt-menu="true" data-kt-menu-expand="false" [class]="menuClass">
    @if (currentTheme.baseSettings.menu.searchActive) {
        <div class="menu-item mb-5 mt-5" aria-haspopup="true" data-ktmenu-submenu-toggle="hover">
            <menu-search-bar></menu-search-bar>
        </div>
    }
    <ng-container [ngTemplateOutlet]="menuListTemplate"></ng-container>
</div>

<ng-template #menuListTemplate>
    @for (child of menu.items; track child) {
        @if (showMenuItem(child)) {
            <ng-container [ngTemplateOutlet]="mMenuItem" [ngTemplateOutletContext]="{ item: child, parentItem: null }"></ng-container>
        }
    }
</ng-template>

<ng-template #mMenuItem let-item="item" let-parentItem="parentItem">
    @if (showMenuItem(item)) {
        <div [attr.data-kt-menu-trigger]="item.items.length ? 'click' : null" [ngClass]="getItemCssClasses(item, parentItem)">
            <!-- if menu item hasn't submenu -->
            @if (!item.items.length && !item.external) {
                <a
                    [queryParams]="item.parameters"
                    [routerLink]="item.route"
                    routerLinkActive="active"
                    class="menu-link"
                    [ngClass]="{ 'without-sub': !item.items.length }"
                    (click)="onMenuItemClick()"
                >
                    <ng-container
                        [ngTemplateOutlet]="mMenuItemText"
                        [ngTemplateOutletContext]="{ item: item, parentItem: parentItem }"
                    ></ng-container>
                </a>
            }
            @if (!item.items.length && item.external) {
                <a [attr.href]="item.route" target="_blank" class="menu-link" (click)="onMenuItemClick()">
                    <ng-container
                        [ngTemplateOutlet]="mMenuItemText"
                        [ngTemplateOutletContext]="{ item: item, parentItem: parentItem }"
                    ></ng-container>
                </a>
            }
            <!-- if menu item has submenu child  -->
            @if (item.items.length) {
                <a
                    href="#"
                    class="menu-link menu-toggle"
                    [class]="{ active: isMenuItemIsActive(item) }"
                    [class.menu-open]="item.expanded"
                    (click)="toggleExpanded(item); $event.preventDefault()"
                >
                    <ng-container
                        [ngTemplateOutlet]="mMenuItemText"
                        [ngTemplateOutletContext]="{ item: item, parentItem: parentItem }"
                    ></ng-container>
                </a>
            }
            <!-- if menu item has submenu child then recursively call new menu item component -->
            @if (item.items.length) {
                <div
                    [class]="getSubMenuItemCssClass(item, parentItem)"
                    [style]="ui.getLeftAsideSubMenuStyles()"
                    [class.show]="item.expanded"
                >
                    <div class="menu-subnav">
                        @for (child of item.items; track child) {
                            <ng-container
                                [ngTemplateOutlet]="mMenuItem"
                                [ngTemplateOutletContext]="{ item: child, parentItem: item }"
                            ></ng-container>
                        }
                    </div>
                </div>
            }
        </div>
    }
</ng-template>

<ng-template #mMenuItemText let-item="item" let-parentItem="parentItem">
    <span class="menu-item-here"></span>
    <!-- if menu item has icon -->
    @if (item.icon) {
        <span class="menu-icon">
            <app-svg-icon [icon]="item.icon"></app-svg-icon>
        </span>
    }

    @if (!item.badge) {
        <!-- menu item title text -->
        @if (!iconMenu || parentItem != null) {
            <span class="menu-title">{{ item.name | localize }}</span>
        }
    } @else {
        <!-- menu item with badge -->
        <span class="menu-link-title">
            <span class="menu-link-wrap">
                <span class="menu-text">
                    {{ item.name | localize }}
                </span>
                <span class="menu-link-badge">
                    <span class="badge badge-primary" [ngClass]="item.badge.type">{{ item.badge.value }}</span>
                </span>
            </span>
        </span>
    }

    @if (item.items.length && (!iconMenu || parentItem != null)) {
        <span class="menu-icon-additional">
            <app-svg-icon [icon]="item.additionalIcon ? item.additionalIcon : 'expand-item'"></app-svg-icon>
        </span>
    }
</ng-template>
<!-- additional settings menu item -->
<!--<div [class]="menuClass">-->
<!--    <div class="side-bar-menu">-->
<!--        <div class="menu-item">-->
<!--            <button (click)="onSettingsClick()" class="menu-link">-->
<!--                <span class="menu-title-settings">Настройки</span>-->
<!--            </button>-->
<!--        </div>-->
<!--    </div>-->
<!--</div>-->
